import { connect } from 'react-redux';
import * as organizationConstants from '../../constants/organizations';
import * as organizationSelectors from '../../selectors/organizationSelectors';
import OrganizationInfo from '../../components/organizationInfo/OrganizationInfo';

const mapStateToProps = state => {
    const organization = organizationSelectors.getOrganization(state);
    return {
        picture: organization.pictureLargeURL,
        title: organization.name,
        isAdmin: organizationSelectors.getIsCurrentUserAdminForOrganization(
            state,
        ),
    };
};

const mapDispatchToProps = dispatch => ({
    onAvatarChange: avatar => {
        dispatch({
            type: organizationConstants.UPDATE_ORGANIZATION_AVATAR_REQUEST,
            payload: {
                avatar,
            },
        });
    },
    onTitleChange: title => {
        dispatch({
            type: organizationConstants.UPDATE_ORGANIZATION_SETTINGS_REQUEST,
            payload: title,
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrganizationInfo);



// WEBPACK FOOTER //
// ./src/containers/organizationInfo/OrganizationInfo.js